"use client";

import { useEffect, useRef } from "react";
import { ChevronDown } from "lucide-react";

/** Native disclosure: usable by keyboard and touch, with ordinary crawlable links. */
export function SectorMenu({ onNavigate }: { onNavigate?: () => void }) {
  const ref = useRef<HTMLDetailsElement>(null);
  useEffect(() => {
    const outside = (event: PointerEvent) => {
      if (!ref.current?.contains(event.target as Node)) ref.current?.removeAttribute("open");
    };
    document.addEventListener("pointerdown", outside);
    return () => document.removeEventListener("pointerdown", outside);
  }, []);
  return (
    <details ref={ref} className="group relative" onKeyDown={event => {
      if (event.key === "Escape") {
        ref.current?.removeAttribute("open");
        ref.current?.querySelector("summary")?.focus();
      }
    }} onBlur={event => {
      if (!event.currentTarget.contains(event.relatedTarget)) ref.current?.removeAttribute("open");
    }}>
      <summary className="flex min-h-11 cursor-pointer list-none items-center gap-1 text-[0.92rem] font-medium [&::-webkit-details-marker]:hidden">
        Sector <ChevronDown aria-hidden="true" className="size-3.5 transition-transform group-open:rotate-180 motion-reduce:transition-none" />
      </summary>
      <div className="z-50 min-w-48 border border-[color-mix(in_srgb,var(--theme-ink)_15%,transparent)] bg-[var(--theme-ground)] p-2 text-[var(--theme-ink)] shadow-sm lg:absolute lg:left-0 lg:top-full">
        {[{ href: "/for/accountants", label: "Accountants" }, { href: "/for/consultancies", label: "Consultancies" }].map(link => <a key={link.href} href={link.href} className="flex min-h-11 items-center px-3 text-sm hover:bg-black/5 focus-visible:outline-2 focus-visible:outline-offset-2" onClick={() => {
          ref.current?.removeAttribute("open");
          onNavigate?.();
        }}>{link.label}</a>)}
      </div>
    </details>
  );
}
